/** Deployment/stage name from Vite (e.g. prod, test). Mocked in Jest. */
export function getViteAppEnvironment(): string {
  return import.meta.env.VITE_APP_ENVIRONMENT;
}
